import { Card, Row, Button, message, Spin } from "antd";
import { useState, useEffect } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";

const LastApp = () => {
    const navigate = useNavigate();
    const [app, setApp] = useState(null);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        const fetch = async () => {
            const apps_res = await HTTPClient.get("/app/");
            const tmpApp = apps_res?.data[apps_res?.data?.length - 1];
            if (!tmpApp) return message.error(t("home.last_app.not_found"));
            const resAppsBundles = await HTTPClient.get("/app/_app_typologies");
            if (resAppsBundles?.data) {
                const present = resAppsBundles.data.find((a) => a.value === tmpApp.technology);
                if (present) {
                    tmpApp.img = present.img;
                }
            }
            setApp(tmpApp);
        };

        fetch();
        setLoading(false);
    }, []);

    if (loading) return <Spin size="large" />;
    if (!app) return null;

    return (
        <Card
            bordered={true}
            style={{
                width: "100%",
                borderRadius: "10px",
                marginTop: "20px",
            }}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "250px",
                    justifyContent: "space-between",
                }}>
                <div>
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                        }}>
                        <img
                            src={app?.img}
                            alt={app?.name}
                            style={{ width: "200px", height: "auto" }}
                        />
                    </Row>
                </div>

                <Button
                    type="primary"
                    style={{ bottom: "0", width: "100%", fontWeight: "bold" }}
                    onClick={() => {
                        navigate("/pro/myapps/" + app?.name);
                    }}>
                    {app?.name}
                </Button>
            </div>
        </Card>
    );
};
export { LastApp };
